import * as React from "react";
import classnames from "classnames";

import styles from "./Button.module.scss";

export interface ButtonProps {
  className?: string;
  action?: any;
  text?: string;
  theme: "primary" | "secondary";
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;
  autoFocus?: boolean;
}

export const Button: React.FC<ButtonProps & React.PropsWithChildren> = (
  props
) => {
  const cx = classnames.bind(styles);

  return (
    <button
      autoFocus={props.autoFocus || false}
      disabled={props.disabled || false}
      className={cx(styles.button, styles[props.theme], props.className)}
      type={props.type}
      onClick={(args) => {
        return props.action ? props.action(args) : null;
      }}
    >
      {props.text || props.children}
    </button>
  );
};
